import { Fragment, useRef, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import CloseModal from "../form/CloseModal";

const Block = ({ customClass, children }) => {
  return (
    <span className={`${customClass}${" flex h-auto text-center flex-nowrap block text-md text-primary"}`}>
      {children}
    </span>
  )
}

export default function ShowHelpModal({ open, setOpen, helpToShow }) {

  const cancelButtonRef = useRef(null);

  const [data, setData] = useState({});

  useEffect(() => {
    if (!open) {
      setData({});
    } else {
      setData(helpToShow);
    }
  }, [open]);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <div
          className="flex items-start md:items-end justify-center min-h-screen pt-4 px-4 pt-48 md:pb-20 text-center sm:block
         sm:p-0"
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="inline-block align-bottom rounded-lg
              text-left 
              transform transition-all 
              bg-white
              sm:my-8 sm:align-middle sm:max-w-xl sm:w-full"
            >
              <div className="flex flex-col items-center justify-center h-auto my-8">
                
                <div className="flex flex-col justify-center">
                  <span className="mb-2 text-lg md:text-xl text-center font-bold text-gray-800 uppercase">{helpToShow.title}</span>
                  <>
                    <p className="text-gray-600 text-center"></p>
                    <p className="text-white text-center select-none">Enter end you instructions to reset your password.</p>
                  </>
                  <div className="w-full px-8 -mt-8 md:mt-0">
                    {/* <span className="block text-md font-semibold text-gray-400">
                      Description : 
                    </span> */}
                    <Block>
                      {data.text}
                    </Block>
                  </div>
                </div>
              </div>
              <CloseModal onClick={() => setOpen(false)} />
            </div>
          </Transition.Child >
        </div >
      </Dialog >
    </Transition.Root >
  );
}
